export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14814.7e8768cc.jpg";